import React from 'react';
import { Box } from '@mui/material';
import Brand from '../components/HomeComponent/Brand';
import ServicesSection from '../components/HomeComponent/ServicesSection';
import Footer from '../components/HomeComponent/Footer';
import Banner from '../components/HomeComponent/Banner';
import GlobalBand from '../components/HomeComponent/GlobalBand';
import SuccessStory from '../components/globalCountries/countryhomepagescomponent/SuccessStory';
import News from "../components/globalCountries/countryhomepagescomponent/News";
import WhyUclean from '../components/HomeComponent/WhyUclean';
import CountryBorder from '../components/globalCountries/countryhomepagescomponent/Countryborder';
import WorldMapWithCountryTooltip from '../components/HomeComponent/countrywhereweserve';
import AppInfoGlobal from '../components/HomeComponent/AppInfoGlobal';
const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

const Home = () => {
  return (
    <Box>
      <Banner/>
      <Brand  />
       <ServicesSection/>
       <GlobalBand/>
       <SuccessStory/>
        <News/>
        <WhyUclean/>
        <CountryBorder />
            <AppInfoGlobal/>
            <WorldMapWithCountryTooltip mapImageSrc={`${imageBaseUrl}worldmapp.svg`} />
               <News/>
      <Footer />
    </Box>
  );
};

export default Home;
